// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-view-main-div {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgb(248, 248, 248);
}

.div-2 {
  padding: 2% 8% 0 8%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  height: 100%;
}

.div-2-span-1 {
  color: var(--Dark, #222731);

  /* Mini Header */

  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  /* 10px */
}


.div-2-span-2 {
  color: var(--Dark, #222731);

  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  /* margin-top: 8%; */


}


.div-2-span-3 {
  color: var(--Dark, #222731);

  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* margin-top: 2%; */
  text-align: center;
  /* 153.846% */
}



.div-2-span-4 {
  color: var(--Dark, #222731);

  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  /* margin-top: 7%; */
  display: flex;
  width: 100%;
}

.div-2-div-1 {
  display: flex;
  gap: 10px;
  /* margin-top: 16px */
}

.div-2-div-1-div-1 {
  display: flex;
  padding: 10px 0px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1 0;
  border-radius: 7px;
  border: 1px solid var(--Borders, #C5C5C5);
}

.div-2-div-1-div-1-span {
  color: #000;
  text-align: center;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.upload-btn {
  display: flex !important;
  padding: 16px !important;
  justify-content: center !important;
  align-items: flex-start !important;
  gap: 6px !important;
  border-radius: 6px !important;
  background: var(--Dark, #222731) !important;
  color: var(--White, var(--content-text-100, #FFF)) !important;

  /* Sub Headers */
  font-size: 13px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
  text-transform: capitalize !important;
  width: 100%;
}

.upload-btn.css-1e6y48t-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  background-color: #C5C5C5 !important;
}

.video-confirm-btn {
  display: flex !important;
  padding: 16px !important;
  justify-content: center !important;
  align-items: flex-start !important;
  gap: 6px !important;
  border-radius: 6px;
  background: #6F7684 !important;
  color: var(--White, var(--content-text-100, #FFF)) !important;

  /* Sub Headers */
  font-size: 13px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
  text-transform: capitalize !important;
  width: 100%;
}

.div-2-span-5 {
  margin-top: 4%;
  text-align: center;
  color: var(--Dark, #222731);

  /* Mini Header */

  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;

}

.div-2-span-5 a {
  /* margin-top: 25px; */
  text-align: center;
  color: var(--Dark, #222731);

  /* Mini Header */

  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}

.progress-model .css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  border-radius: 8px;
  border: 1.5px solid rgba(255, 255, 255, 0.30);
  background: rgba(34, 39, 49, 0.90);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.18);
  -webkit-backdrop-filter: blur(7.5px);
          backdrop-filter: blur(7.5px);

}

.progress-model-div {
  display: flex;
  width: 252px;
  padding: 12px 14px 15px 14px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
}

.progress-model-div-span {
  color: var(--content-text-100, #FFF);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.upload-successful-div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  padding: 24px;
}

.back-btn {
  color: var(--Dark, #222731);

  /* Sub Headers */

  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.step2-div {
  display: flex;
  padding: 15px;
  flex-direction: column;
  justify-content: space-between;
  height: 97%;

}

.step1-div {
  display: flex;
  padding: 15px;
  flex-direction: column;
  background-color: #000;
  height: 100%;
}

.step3-div {
  display: flex;
  padding: 15px;
  flex-direction: column;
  height: 97%;

}

.step2-div-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content-tag-span {
  display: flex;
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 40px;
  border: 1px solid #64686F;
  background: #222731;
  font-size: 12px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-wrap: nowrap;
}

.selected-tag-span {
  background: var(--Dark, #222731);
}

.step2-div-3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  max-width: 450px;
}

.step2-div-3-div {
  display: flex;
  gap: 10px;
  justify-items: center;
  align-items: center;
  margin-top: 10px;
}

.mobile-stepper {
  justify-content: center !important;
  background-color: transparent !important;
}

.step-2-mobile-stepper {
  justify-content: center !important;
  background-color: transparent !important;
}

.step-2-mobile-stepper .css-26w9jf-MuiMobileStepper-dot {
  background-color: #222731;
}

.mobile-stepper .css-26w9jf-MuiMobileStepper-dot {
  background-color: #FFF;
}

.mobile-stepper.css-11syc77-MuiPaper-root-MuiMobileStepper-root {
  background-color: transparent;
}

.mobile-stepper .css-114p2tk-MuiMobileStepper-dot {
  background-color: rgb(255 255 255 / 26%);
}

/* .step1-back-arrow {
  position: absolute;
  top: 2%;
  left: 4%
} */

.step1-bottom-div {
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
}

.info-div {
  display: flex;
  flex-direction: column;
  gap: 16px;

  margin: auto;
  width: 85%;
}

.info-text {
  color: var(--Dark, #222731);
  display: flex;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.info-text-1 {
  color: var(--Dark, #222731);

  /* Paragraph */
  display: flex;

  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
mux-player {
  height: calc(100% - 50px);
  border-radius: 7px;
}
.info-input {
  border: none !important;
  border-radius: 4px;
  background: #ECECEC;
  display: flex;
  padding: 12px 12px 12px 11px;
  align-items: center;
  align-self: stretch;
  margin-top: 12px;
}

.info-text-label {
  color: var(--Dark, #222731);

  /* Sub Headers */
  display: flex;

  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 20px;
}

.info-div-1 {
  display: flex;
  flex-direction: column;
  margin-top: 18px;
}


.playerStyle {
  display: flex;
  gap: 20px;
  flex-direction: column;
  padding-top: 5px;
  height: calc(100% - 70px);
}

.swiper-div-1 {
  display: flex !important;
  padding: 9px 10px !important;
  flex-direction: column !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 5px !important;
  border-radius: 4px !important;
  border: 1px solid var(--MD-Gray, #E9E9E9) !important;
  background: var(--content-text-100, #FFF) !important;
  box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.08) !important;
  width: 140px !important;
  height: 150px !important;
  margin-right: 10px !important;
}

.swiper-div-2 {
  display: flex !important;
  padding: 9px 10px !important;
  flex-direction: column !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 5px !important;
  border-radius: 4px !important;
  border: 1px solid var(--MD-Gray, #E9E9E9) !important;
  background: var(--content-text-100, #FFF) !important;
  box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.08) !important;
  width: 100px !important;
  height: 150px !important;
  margin-right: 10px !important;
}

.swiper-div-1 span {
  color: #222731;
  text-align: center;

  /* Mini Header */
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  /* 10px */
  opacity: 0.7;
}

.swiper-div-2 span {
  color: #222731;
  text-align: center;

  /* Mini Header */
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  /* 10px */
  opacity: 0.7;
}

.preview-slide {
  background-color: #000;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 15px;
}

.preview-slide-close-btn {
  display: flex !important;
  height: 44px !important;
  padding: 16px !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 6px !important;
  align-self: stretch !important;
  border-radius: 6px !important;
  background: var(--content-text-100, #FFF) !important;
  color: var(--Black, #000) !important;

  /* Sub Headers */
  font-size: 13px !important;
  font-style: normal !important;
  font-family: Inter;

  font-weight: 600 !important;
  line-height: normal !important;
  text-transform: capitalize !important;
  position: absolute !important;
  bottom: 2%;
  width: 92%;
}

.step-1-bottom-div {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 18%;
}



.thumbnailSwiper .swiper-button-next { 
padding: 16px;
height: 50px;
width: 40px;
right: -2px;
top: 8px;
background-color: rgba(0, 0, 0, 0.8);
}
.thumbnailSwiper .swiper-button-prev { 
padding: 16px;
height: 50px;
width: 40px;
left: -2px;
top: 8px;
background-color: rgba(0, 0, 0, 0.9);
}

.thumbnailSwiper  { 
  display: flex !important;
  --swiper-navigation-size: 16px;
  --swiper-theme-color : white
}
.thumbnailSwiper .swiper-wrapper { 
  width: calc(100% - 100px);
}

`, "",{"version":3,"sources":["webpack://./src/MobileView/MobileView.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;;EAE3B,gBAAgB;;EAEhB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;;AAGA;EACE,2BAA2B;;EAE3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;;;AAGtB;;;AAGA;EACE,2BAA2B;;EAE3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;;;AAIA;EACE,2BAA2B;;EAE3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,SAAW;EACX,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,2CAA2C;EAC3C,6DAA6D;;EAE7D,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,6DAA6D;;EAE7D,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;;EAE3B,gBAAgB;;EAEhB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;;EAE3B,gBAAgB;;EAEhB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,kCAAkC;EAClC,+CAA+C;EAC/C,oCAA4B;UAA5B,4BAA4B;;AAE9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oCAAoC;;EAEpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,2BAA2B;;EAE3B,gBAAgB;;EAEhB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;;AAEb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;;AAEb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;;EAE3B,cAAc;EACd,aAAa;;EAEb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;;EAE3B,gBAAgB;EAChB,aAAa;;EAEb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;EACjC,oCAAoC;EACpC,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oDAAoD;EACpD,oDAAoD;EACpD,2DAA2D;EAC3D,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;EACjC,oCAAoC;EACpC,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oDAAoD;EACpD,oDAAoD;EACpD,2DAA2D;EAC3D,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;;EAElB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;;EAElB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,oDAAoD;EACpD,oCAAoC;;EAEpC,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;;EAElB,2BAA2B;EAC3B,8BAA8B;EAC9B,qCAAqC;EACrC,6BAA6B;EAC7B,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;;;AAIA;AACA,aAAa;AACb,YAAY;AACZ,WAAW;AACX,WAAW;AACX,QAAQ;AACR,oCAAoC;AACpC;AACA;AACA,aAAa;AACb,YAAY;AACZ,WAAW;AACX,UAAU;AACV,QAAQ;AACR,oCAAoC;AACpC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B;AACF;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".mobile-view-main-div {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: rgb(248, 248, 248);\n}\n\n.div-2 {\n  padding: 2% 8% 0 8%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  text-align: center;\n  height: 100%;\n}\n\n.div-2-span-1 {\n  color: var(--Dark, #222731);\n\n  /* Mini Header */\n\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n  /* 10px */\n}\n\n\n.div-2-span-2 {\n  color: var(--Dark, #222731);\n\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  /* margin-top: 8%; */\n\n\n}\n\n\n.div-2-span-3 {\n  color: var(--Dark, #222731);\n\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  /* margin-top: 2%; */\n  text-align: center;\n  /* 153.846% */\n}\n\n\n\n.div-2-span-4 {\n  color: var(--Dark, #222731);\n\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  /* margin-top: 7%; */\n  display: flex;\n  width: 100%;\n}\n\n.div-2-div-1 {\n  display: flex;\n  gap: 10px;\n  /* margin-top: 16px */\n}\n\n.div-2-div-1-div-1 {\n  display: flex;\n  padding: 10px 0px;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n  border-radius: 7px;\n  border: 1px solid var(--Borders, #C5C5C5);\n}\n\n.div-2-div-1-div-1-span {\n  color: #000;\n  text-align: center;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.upload-btn {\n  display: flex !important;\n  padding: 16px !important;\n  justify-content: center !important;\n  align-items: flex-start !important;\n  gap: 6px !important;\n  border-radius: 6px !important;\n  background: var(--Dark, #222731) !important;\n  color: var(--White, var(--content-text-100, #FFF)) !important;\n\n  /* Sub Headers */\n  font-size: 13px !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  line-height: normal !important;\n  text-transform: capitalize !important;\n  width: 100%;\n}\n\n.upload-btn.css-1e6y48t-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  background-color: #C5C5C5 !important;\n}\n\n.video-confirm-btn {\n  display: flex !important;\n  padding: 16px !important;\n  justify-content: center !important;\n  align-items: flex-start !important;\n  gap: 6px !important;\n  border-radius: 6px;\n  background: #6F7684 !important;\n  color: var(--White, var(--content-text-100, #FFF)) !important;\n\n  /* Sub Headers */\n  font-size: 13px !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  line-height: normal !important;\n  text-transform: capitalize !important;\n  width: 100%;\n}\n\n.div-2-span-5 {\n  margin-top: 4%;\n  text-align: center;\n  color: var(--Dark, #222731);\n\n  /* Mini Header */\n\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n\n}\n\n.div-2-span-5 a {\n  /* margin-top: 25px; */\n  text-align: center;\n  color: var(--Dark, #222731);\n\n  /* Mini Header */\n\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n}\n\n.progress-model .css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n  border-radius: 8px;\n  border: 1.5px solid rgba(255, 255, 255, 0.30);\n  background: rgba(34, 39, 49, 0.90);\n  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.18);\n  backdrop-filter: blur(7.5px);\n\n}\n\n.progress-model-div {\n  display: flex;\n  width: 252px;\n  padding: 12px 14px 15px 14px;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  flex-shrink: 0;\n}\n\n.progress-model-div-span {\n  color: var(--content-text-100, #FFF);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.upload-successful-div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column;\n  padding: 24px;\n}\n\n.back-btn {\n  color: var(--Dark, #222731);\n\n  /* Sub Headers */\n\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.step2-div {\n  display: flex;\n  padding: 15px;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 97%;\n\n}\n\n.step1-div {\n  display: flex;\n  padding: 15px;\n  flex-direction: column;\n  background-color: #000;\n  height: 100%;\n}\n\n.step3-div {\n  display: flex;\n  padding: 15px;\n  flex-direction: column;\n  height: 97%;\n\n}\n\n.step2-div-2 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.content-tag-span {\n  display: flex;\n  padding: 8px 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  border-radius: 40px;\n  border: 1px solid #64686F;\n  background: #222731;\n  font-size: 12px;\n  font-family: Inter;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-wrap: nowrap;\n}\n\n.selected-tag-span {\n  background: var(--Dark, #222731);\n}\n\n.step2-div-3 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 30px;\n  max-width: 450px;\n}\n\n.step2-div-3-div {\n  display: flex;\n  gap: 10px;\n  justify-items: center;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.mobile-stepper {\n  justify-content: center !important;\n  background-color: transparent !important;\n}\n\n.step-2-mobile-stepper {\n  justify-content: center !important;\n  background-color: transparent !important;\n}\n\n.step-2-mobile-stepper .css-26w9jf-MuiMobileStepper-dot {\n  background-color: #222731;\n}\n\n.mobile-stepper .css-26w9jf-MuiMobileStepper-dot {\n  background-color: #FFF;\n}\n\n.mobile-stepper.css-11syc77-MuiPaper-root-MuiMobileStepper-root {\n  background-color: transparent;\n}\n\n.mobile-stepper .css-114p2tk-MuiMobileStepper-dot {\n  background-color: rgb(255 255 255 / 26%);\n}\n\n/* .step1-back-arrow {\n  position: absolute;\n  top: 2%;\n  left: 4%\n} */\n\n.step1-bottom-div {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 90%;\n}\n\n.info-div {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  margin: auto;\n  width: 85%;\n}\n\n.info-text {\n  color: var(--Dark, #222731);\n  display: flex;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.info-text-1 {\n  color: var(--Dark, #222731);\n\n  /* Paragraph */\n  display: flex;\n\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\nmux-player {\n  height: calc(100% - 50px);\n  border-radius: 7px;\n}\n.info-input {\n  border: none !important;\n  border-radius: 4px;\n  background: #ECECEC;\n  display: flex;\n  padding: 12px 12px 12px 11px;\n  align-items: center;\n  align-self: stretch;\n  margin-top: 12px;\n}\n\n.info-text-label {\n  color: var(--Dark, #222731);\n\n  /* Sub Headers */\n  display: flex;\n\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin-top: 20px;\n}\n\n.info-div-1 {\n  display: flex;\n  flex-direction: column;\n  margin-top: 18px;\n}\n\n\n.playerStyle {\n  display: flex;\n  gap: 20px;\n  flex-direction: column;\n  padding-top: 5px;\n  height: calc(100% - 70px);\n}\n\n.swiper-div-1 {\n  display: flex !important;\n  padding: 9px 10px !important;\n  flex-direction: column !important;\n  justify-content: flex-end !important;\n  align-items: center !important;\n  gap: 5px !important;\n  border-radius: 4px !important;\n  border: 1px solid var(--MD-Gray, #E9E9E9) !important;\n  background: var(--content-text-100, #FFF) !important;\n  box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.08) !important;\n  width: 140px !important;\n  height: 150px !important;\n  margin-right: 10px !important;\n}\n\n.swiper-div-2 {\n  display: flex !important;\n  padding: 9px 10px !important;\n  flex-direction: column !important;\n  justify-content: flex-end !important;\n  align-items: center !important;\n  gap: 5px !important;\n  border-radius: 4px !important;\n  border: 1px solid var(--MD-Gray, #E9E9E9) !important;\n  background: var(--content-text-100, #FFF) !important;\n  box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.08) !important;\n  width: 100px !important;\n  height: 150px !important;\n  margin-right: 10px !important;\n}\n\n.swiper-div-1 span {\n  color: #222731;\n  text-align: center;\n\n  /* Mini Header */\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n  /* 10px */\n  opacity: 0.7;\n}\n\n.swiper-div-2 span {\n  color: #222731;\n  text-align: center;\n\n  /* Mini Header */\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n  /* 10px */\n  opacity: 0.7;\n}\n\n.preview-slide {\n  background-color: #000;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 15px;\n}\n\n.preview-slide-close-btn {\n  display: flex !important;\n  height: 44px !important;\n  padding: 16px !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 6px !important;\n  align-self: stretch !important;\n  border-radius: 6px !important;\n  background: var(--content-text-100, #FFF) !important;\n  color: var(--Black, #000) !important;\n\n  /* Sub Headers */\n  font-size: 13px !important;\n  font-style: normal !important;\n  font-family: Inter;\n\n  font-weight: 600 !important;\n  line-height: normal !important;\n  text-transform: capitalize !important;\n  position: absolute !important;\n  bottom: 2%;\n  width: 92%;\n}\n\n.step-1-bottom-div {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 18%;\n}\n\n\n\n.thumbnailSwiper .swiper-button-next { \npadding: 16px;\nheight: 50px;\nwidth: 40px;\nright: -2px;\ntop: 8px;\nbackground-color: rgba(0, 0, 0, 0.8);\n}\n.thumbnailSwiper .swiper-button-prev { \npadding: 16px;\nheight: 50px;\nwidth: 40px;\nleft: -2px;\ntop: 8px;\nbackground-color: rgba(0, 0, 0, 0.9);\n}\n\n.thumbnailSwiper  { \n  display: flex !important;\n  --swiper-navigation-size: 16px;\n  --swiper-theme-color : white\n}\n.thumbnailSwiper .swiper-wrapper { \n  width: calc(100% - 100px);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
